// Alle möglichen Slider-Instanzen
import Swiper from 'swiper';

const swiperInstances = {

    init() {
        /**
         * "Beliebte Marken"-Slider auf der Startseite
         * @type {Swiper}
         */
        window.Chronoto = window.Chronoto || {};

        const popularbrandsSwiperConfig = window.Chronoto.popularbrandsSwiperConfig || {
            slidesPerView: 2,
            breakpoints: {
                640: {
                    slidesPerView: 4,
                },
                1280: {
                    slidesPerView: 6,
                },
                1600: {
                    slidesPerView: 10,
                },
            },
        };

        // eslint-disable-next-line no-new
        new Swiper('.js-swiper-popularbrands', {
            preloadImages: false,
            slidesPerView: popularbrandsSwiperConfig.slidesPerView,
            centeredSlides: true,
            loop: true,
            breakpoints: popularbrandsSwiperConfig.breakpoints,
            navigation: {
                nextEl: '.js-brand-slider-button-next',
                prevEl: '.js-brand-slider-button-prev',
            },
        });

        /**
         * Slider auf Markenseite
         * @type {Swiper}
         */
        const brandSwiperConfig = window.Chronoto.brandSwiperConfig || {
            slidesPerView: 2,
            breakpoints: {
                640: {
                    slidesPerView: 4,
                },
                1280: {
                    slidesPerView: 6,
                },
                1600: {
                    slidesPerView: 8,
                },
                2000: {
                    slidesPerView: 10,
                },
            },
        };

        // eslint-disable-next-line no-new
        new Swiper('.js-swiper-brand', {
            preloadImages: false,
            slidesPerView: brandSwiperConfig.slidesPerView,
            centeredSlides: true,
            loop: true,
            breakpoints: brandSwiperConfig.breakpoints,
            navigation: {
                nextEl: '.js-brand-slider-button-next',
                prevEl: '.js-brand-slider-button-prev',
            },
        });

        /**
         * "Beliebte Modelle"-Slider auf der Startseite
         * @type {Swiper}
         */
        // eslint-disable-next-line no-new
        new Swiper('.js-swiper-featuredwatches', {
            preloadImages: false,
            slidesPerView: 1,
            pagination: {
                el: '.js-swiper-pagination',
                type: 'bullets',
            },
            breakpoints: {
                1000: {
                    slidesPerView: 2,
                    navigation: {
                        nextEl: '.js-featuredwatches-slider-button-next',
                        prevEl: '.js-featuredwatches-slider-button-prev',
                    },
                },
            },
        });

        /**
         * "Shops im Spotlight"-Logo-Slider auf der Startseite
         */
        // generiert eine zufällige Zahl zwischen 0 und "Anzahl Slides -1"
        // um den Slider bei einer zufälligen Position starten zu lassen
        // https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Math/math.random
        function getRandomInt() {
            const numberOfSlides = document.querySelectorAll('.js-swiper-shops-spotlight-shops .swiper-slide').length;

            const min = Math.ceil(0);
            const max = Math.floor(numberOfSlides);

            return Math.floor(Math.random() * (max - min)) + min;
        }

        const randomNumber = getRandomInt();

        // eslint-disable-next-line no-new
        const logoSwiper = new Swiper('.js-swiper-shops-spotlight-logos', {
            slidesPerView: 2,
            breakpoints: {
                1000: {
                    slidesPerView: 4,
                },
            },
            navigation: {
                nextEl: '.js-shops-spotlight-logos-slider-button-next',
                prevEl: '.js-shops-spotlight-logos-slider-button-prev',
            },
        });

        /**
         * "Shops im Spotlight"-Shop-Slider
         */
        // eslint-disable-next-line no-new
        new Swiper('.js-swiper-shops-spotlight-shops', {
            autoHeight: true,
            initialSlide: randomNumber,
            thumbs: {
                swiper: logoSwiper,
            },
        });
    },
};

export default swiperInstances;
